import { useMemo, useState } from "react";
import { PLYMOUTH_ROUTES, flattenRoutes } from "../utils/routes";

function routeMatches(route, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [route.num, route.title, route.via, route.operator, route.type]
    .filter(Boolean)
    .some((value) => value.toLowerCase().includes(q));
}

function getOperatorClass(operator) {
  if (operator.includes("Stagecoach")) return "operator-stagecoach";
  if (operator.includes("Go Cornwall")) return "operator-cornwall";
  return "operator-citybus";
}

export default function RoutesList() {
  const [query, setQuery] = useState("");
  const [activeType, setActiveType] = useState("All");
  const allRoutes = useMemo(() => flattenRoutes(), []);
  const types = useMemo(() => ["All", ...Array.from(new Set(allRoutes.map((route) => route.type))).sort()], [allRoutes]);

  const filteredSections = useMemo(() => {
    return PLYMOUTH_ROUTES.map((section) => ({
      ...section,
      routes: section.routes.filter((route) => {
        const matchesType = activeType === "All" || route.type === activeType;
        return matchesType && routeMatches(route, query);
      }),
    })).filter((section) => section.routes.length > 0);
  }, [query, activeType]);

  const filteredCount = filteredSections.reduce((count, section) => count + section.routes.length, 0);

  return (
    <div>
      <div className="section-head routes-head">
        <div>
          <div className="section-label">All Plymouth routes</div>
          <div className="section-subtitle">
            {filteredCount} route groups · Plymouth Citybus, Go Cornwall Bus and Stagecoach
          </div>
        </div>
      </div>

      <input
        className="stop-search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search route number, place, operator or area"
        aria-label="Search Plymouth bus routes"
      />

      <div className="route-filter-scroll" aria-label="Filter routes by type">
        {types.map((type) => (
          <button
            key={type}
            className={`route-filter ${activeType === type ? "active" : ""}`}
            onClick={() => setActiveType(type)}
          >
            {type}
          </button>
        ))}
      </div>

      {filteredSections.length === 0 && (
        <div className="card empty-state">No routes matched your search.</div>
      )}

      {filteredSections.map((section) => (
        <section key={section.group} className="route-section">
          <div className="route-group-title">{section.group}</div>
          <div className="card route-card-list">
            {section.routes.map((route) => (
              <article key={`${section.group}-${route.num}`} className="route-row">
                <div className="route-number">{route.num}</div>
                <div className="route-copy">
                  <div className="route-title">{route.title}</div>
                  <div className="route-via">via {route.via}</div>
                  <div className="route-tags">
                    <span className={`operator-pill ${getOperatorClass(route.operator)}`}>{route.operator}</span>
                    <span className="type-pill">{route.type}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      ))}

      <div className="info-box route-note">
        This route list is built into the app for local testing. Live route shapes, stop-by-stop route matching and live departures can be added next through BODS timetable/SIRI data.
      </div>
    </div>
  );
}
